import { TitleColor } from '..';
import Text from '../Text';

const Education2012 = () => (
  <>
    <TitleColor text="Kurser 2012" smallTitle />
    <Text>
      <b>Ray Coppinger</b>
      <br />
      Weekendkursus den 8.-9. september 2012: "The evolution of dogs and behavior of the dogs".
    </Text>
    <Text>
      <b>Christa fra Tellington TTouch</b>
      <br />
      Weekendkursus den 31. august-1. september 2012: "TTouch training and massage".
    </Text>
    <Text>
      <b>Kathy Sdao</b>
      <br />
      Weekendkursus den 4.-5. juli 2012: "Cues and behavior chains".
    </Text>
    <Text>
      <b>Marc Pierard</b>
      <br />
      Seminar den 23. marts 2012: "Nøglen til succesfuld træning" af heste.
    </Text>
  </>
);

export default Education2012;
